import { TableCell, TableRow, Typography } from '@mui/material'

const CustomersResellersRow = ({ row }) => {
  const { id, name, type, numberOfOrders, revenue } = row

  return (
    <TableRow hover key={id}>
      <TableCell>
        <Typography fontWeight={50} fontSize={18}>
          {name}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography
          fontWeight={50}
          fontSize={18}
          textTransform="capitalize"
          color={type === 'direct' ? '#00A43B' : '#220D77'}
        >
          {type}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography fontWeight={50} fontSize={18}>
          {numberOfOrders}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography fontWeight={50} fontSize={18}>
          {typeof revenue === 'number'
            ? `€${revenue.toLocaleString('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`
            : revenue}
        </Typography>
      </TableCell>
    </TableRow>
  )
}

export default CustomersResellersRow
